import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";

export const requestDeleteEnrichmentProfile = async (
  categoryId: string
): Promise<{ ok: true }> => {
  return await instance.delete(
    `${ApiRoutesRecommendation.EnrichmentProfiles}/${categoryId}`
  );
};
